import React, { useEffect } from "react";
import { useState } from "react";
import data from "./body.json";
import "./BodyShape.css";
import { createClient } from "contentful";

const client = createClient({
  space: process.env.REACT_APP_SPACE_ID,
  accessToken: process.env.REACT_APP_ACCESS_TOKEN,
});

const BodyShape = ({
  setVal,
  val,
  setStyle,
  setColor,
  setBackground,
  nextPageHandler,
}) => {
  const [selectImg, setSelectImg] = useState(15);
  const [avatar, setAvatar] = useState();

  useEffect(async() => {
    const entry = await client.getEntries({
      content_type: "bodyShape",
      order: "sys.id",
    });
    setAvatar(entry?.items);
  }, []);
  
  useEffect(() => {
   
    
  }, [avatar]);
 
  const handleClick = (val, style_number, Color, Background, key) => {
    setStyle(style_number);
    setVal(val);
    setSelectImg(key);
    setColor(Color);
    setBackground(Background);
  };

  return (
    <div className="get-start">
      <div className="container shape-selection-area">
        <div className="heading-getstarted">
          <h6 className="get">GET STARTED</h6>
          <h4 className="get-text ">
            Select a body shape that best resembles your figure.
          </h4>
        </div>

        <div className="image-grid">
          {data?.map((element, key) => (
              <img
                key={key}
                src={element.image}
                onClick={(e) =>
                  handleClick(
                    element.id,
                    element.style_number,
                    element.color,
                    element.background,
                    key
                  )
                }
              />
          ))}
        </div>
      </div>
    </div>
  );
};

export default BodyShape;
